import React from "react";

import EmailForm from "./EmailForm";

const ResetPassword = () => {
  return <EmailForm />;
};

export default ResetPassword;
